import { computed, ref } from 'vue'
import { useUserStore, useSystemStore } from '@/stores'
import * as utils from '@/utils/util'
import HomeService from '@/services/home.service'
import type { FloorItem, Room } from '@/types/home.type'
import { useRoute, useRouter } from 'vue-router';
import { Floor } from '@/components/shop/floor';

export default function useHomeState() {
  const homeService = new HomeService()
  const carouselBanners = ref<FloorItem[]>()
  // const iconList = ref<Floor[]>([])
  // const picTextList = ref<Floor[]>([])
  // const picList = ref<Floor[]>([])
  const customList = ref<(FloorItem | {})[]>([]);
  const skeleton = ref(false);
  const useUser = useUserStore()
  const useSystem = useSystemStore()
  const isLogin = computed(() => useUser.isLogin)
  const cutdownDay = computed(() =>
    utils.getDaysBetween(utils.formatTime(new Date(), 'yyyy-MM-dd'), '2023-07-28')
  )
  const qrCodeModelRef = ref();
  const router = useRouter();
  const components = ref<Floor[]>([]);
  async function loadHomeData(query: {id?: string | undefined, page?: string}) {
    if (query?.page === 'HOME') {
      components.value = useSystem?.components || [];
      carouselBanners.value = useSystem?.components?.find((item) => item.type === "SLIDE_IMAGE_S")?.items;
      const items = useSystem?.components?.find((item) => item.type === "SHOW_LIST")?.items?.[0]?.values;
      if (items?.length) {
        customList.value = items;
        const blankCount = 4 - customList.value.length % 4;
        if (blankCount > 0 && blankCount < 4) {
          customList.value.push(...Array.from({ length: blankCount }, (_, i) => ({ id: i + 1 })))
        }
      }
      return;
    }
    skeleton.value = true;
    try {
      const params: any = {
        cityId: 'BL1034',
        page: query?.page,
      }
      if (query?.id) {
        params.id = query.id;
      }
      const { statusCode, data } = await homeService.getFloorInfos(params)
      if (statusCode === 200 && data) {
        components.value = data?.components || [];
      }
      skeleton.value = false;
    } catch (error) {
      components.value = [];
      carouselBanners.value = [];
      customList.value = [];
    }
  }

  async function getShopInfos() {
    const { statusCode, data } = await homeService.getShopInfos()
    if (statusCode === 200) {
      return data
    }
  }

  function openActivity(item: any) {
    const { navigateUrl } = item;
    if (!navigateUrl) {
      return
    }
    const pathVal = utils.getLastPath(navigateUrl)
    // 演出详情
    if (pathVal == 'show_detail') {
      const showId = utils.parseQueryString(navigateUrl).showId
      const h5URL  = `${location.origin}/content/${showId}`;
      qrCodeModelRef.value.showLoginModal(item.showName, h5URL);
      return
    }
    // 列表搜索
    if (pathVal == 'show_search') {
      const keyword = utils.parseQueryString(navigateUrl).keywords
      window.open(`${location.origin}/list?keyword=${keyword}`, '_blank')
      return
    }
    // 专题
    if (navigateUrl.includes('topic-activity')) {
      window.open(`${location.origin}/topic-activity/${navigateUrl.split('topic-activity/')[1]}`, '_blank')
      return
    }
    window.open(navigateUrl, '_blank')
  }

  const toHome = () => {
    router.push({path: '/'})
  }

  const toMember = () => {
    window.location.href = 'https://shop132088085.m.youzan.com/wscshop/showcase/homepage?kdt_id=131895917&reft=1684821074517&spm=f.118078788&sf=qq_sm&is_share=1&shopAutoEnter=1&share_cmpt=native_wechat&from_uuid=ea40be1c-4d27-319f-fb33-176490b7c8fb';
  }

  const toList = () => {
    router.push({path: '/list'});
  }

  return {
    toHome,
    toMember,
    toList,
    isLogin,
    skeleton,
    cutdownDay,
    loadHomeData,
    getShopInfos,
    carouselBanners,
    // iconList,
    // picList,
    // picTextList,
    customList,
    openActivity,
    qrCodeModelRef,
    components,
  }
}
